"use client"; // Error components must be Client Components

import { ResetPage } from "@/components/ResetPage";
import { useRollbar } from "@rollbar/react";
import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const rollbar = useRollbar();
  useEffect(() => {
    rollbar.error(error);
  }, [error, rollbar]);

  return <ResetPage reset={reset} />;
}
